import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";

const Dashboard = () => {
  const [data, setData] = useState({})
  const [userRole, setUserRole] = useState(localStorage.getItem("userData"));

  const fetchData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
    setData(response?.data?.counts);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(()=>{
    if(localStorage.getItem("userData")){
      setUserRole(JSON.parse(localStorage.getItem("userData")))
    }
  },[])
  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 p-6 bg-gray-50">
        {/* Dashboard Header */}
        <h1 className="text-2xl font-bold text-black mb-6">Dashboard Overview</h1>

        {/* Cards Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-lg font-bold text-gray-800 mb-2">Total Students</h2>
            <p className="text-4xl font-bold text-blue-500">{data?.studentCount}</p>
          </div>
         {userRole?.role==="admin" && <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-lg font-bold text-gray-800 mb-2">Total Employees</h2>
            <p className="text-4xl font-bold text-orange-500">{data?.employeeCount}</p>
          </div>}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-lg font-bold text-gray-800 mb-2">Total Colleges</h2>
            <p className="text-4xl font-bold text-blue-500">{data?.collegeCount}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-lg font-bold text-gray-800 mb-2">Total Courses</h2>
            <p className="text-4xl font-bold text-blue-500">{data?.courseCount}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
